import styles from "./sidebar.module.scss";
import { NavLink } from "react-router-dom";
import { Accordion, AccordionDetails, AccordionSummary, List } from "@material-ui/core";
import classNames from "classnames";
import { UserRoleAccess as Navigation } from "enums";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useContext } from "react";
import { FeatureFlagContext, UserContext } from "contexts";
import { SidebarImage, StocqLogo } from "images";
import { Image } from "components/commons";

const ChildItem = (props) => {
  const { hasFeature } = useContext(FeatureFlagContext);
  const { styles, item } = props;

  const visibleChildren = item.items?.filter((child) =>
    child.key ? hasFeature(`PAGE_${child.key}`) : true,
  );

  const isShowParent = () => {
    if (!item.expanded) return true;
    return (visibleChildren?.length || 0) > 0;
  };

  if (!visibleChildren || visibleChildren.length === 0) {
    return (
      <NavLink
        to={item.link}
        className={classNames(styles.listItem)}
        activeClassName={styles.selectedMenu}
      >
        <span className={styles.item}>
          <span className={styles.listIconRoot}>
            <Image src={item.icon} className={styles.iconCustom} />
          </span>
          <span className={styles.listText}>{item.label}</span>
        </span>
      </NavLink>
    );
  }

  return (
    isShowParent() && (
      <Accordion elevation={0} className={styles.accordionDetails} defaultExpanded={item.expanded}>
        <AccordionSummary expandIcon={<ExpandMoreIcon className={styles.expandIcon} />}>
          <NavLink
            to={item.link}
            className={classNames(styles.listItem, styles.disableLink)}
            activeClassName={styles.selectedMenu}
          >
            <span className={styles.item}>
              <span className={styles.listIconRoot}>
                <Image src={item.icon} className={styles.iconCustom} />
              </span>
              <span className={styles.listText}>{item.label}</span>
            </span>
          </NavLink>
        </AccordionSummary>
        <AccordionDetails>
          <div className={styles.child}>
            {visibleChildren.map((child, childKey) => (
              <NavLink
                key={childKey}
                to={child.link}
                exact={child.exact}
                className={classNames(styles.listItem)}
                activeClassName={styles.active}
              >
                <span className={styles.listIconRoot}></span>
                <span className={styles.listText}>{child.label}</span>
              </NavLink>
            ))}
          </div>
        </AccordionDetails>
      </Accordion>
    )
  );
};

const Sidebar = () => {
  const { user } = useContext(UserContext);

  const role = user?.userAccesses.find((element) => element.portal === "hos")?.role;

  const { hasFeature } = useContext(FeatureFlagContext);

  const filteredNavigation = Navigation.filter((item) => {
    if (item.key && !hasFeature(`PAGE_${item.key}`)) {
      return false;
    }

    if (item.permission?.length) {
      return item.permission.some((p) => p.role === role);
    }

    return true;
  });

  return (
    <div className={classNames(styles.sidebarContainer)}>
      <div className={styles.logoContainer}>
        <Image src={StocqLogo} className={styles.logo} />
      </div>

      <div className={styles.smallColorBox}></div>

      <List className={styles.sidebarList}>
        {filteredNavigation.map((item, index) => (
          <span key={index}>
            {item.exact ? (
              <NavLink
                to={item.link}
                exact
                className={classNames(styles.listItem)}
                activeClassName={styles.selectedMenu}
              >
                <span className={styles.item}>
                  <span className={styles.listIconRoot}>
                    <Image src={item.icon} className={styles.iconCustom} />
                  </span>
                  <span className={styles.listText}>{item.label}</span>
                </span>
              </NavLink>
            ) : (
              <ChildItem styles={styles} item={item} role={role} />
            )}
          </span>
        ))}
      </List>

      <div>
        <Image src={SidebarImage} className={styles.sidebar_image} />
      </div>
    </div>
  );
};

export default Sidebar;
